import axios from '../../../config/axiosConfig';
import { RosterRequest, RosterResponse, RostersResponse, RosterStudentResponse, StudentInfo } from '../../../Components/Modals/models';
import { ROSTERS_RESPONSE } from './rosters.constants';
import { ROSTER_RESPONSE, ROSTER_STUDENT_RESPONSE } from '../../../Components/Modals/models/Modal.constants';

export const fetchRostersAsync = async(
): Promise<RostersResponse> => {
  const response = await axios.post<RostersResponse>('api/roster/rosters')
    .then(res => ({...res.data, __typename: ROSTERS_RESPONSE}))
    .catch((err: string) => {
      return {
        __typename: ROSTERS_RESPONSE,
        success: false,
        rosterList: [],
        errMsg: err
      };
    });
  return response;
};

export const fetchAddRosterAsync = async(
  newRoster: RosterRequest,
): Promise<RosterResponse> => {
  const response = await axios.post<RosterResponse>('api/roster/add', newRoster)
    .then( res => ({...res.data, __typename: ROSTER_RESPONSE}))
    .catch( (errMsg): RosterResponse => ({
      __typename: ROSTER_RESPONSE,
      success: false,
      rosterID: -1,
      errMsg
    }));
  return response;
};

export const fetchEditRosterAsync = async(
  roster: RosterRequest,
): Promise<RosterResponse> => {
  const response = await axios.post<RosterResponse>('api/roster/update', roster)
    .then( res => ({...res.data, __typename: ROSTER_RESPONSE}))
    .catch( (errMsg): RosterResponse => ({
      __typename: ROSTER_RESPONSE,
      success: false,
      rosterID: -1,
      errMsg
    }));
  return response;
};

export const deleteRosterAsync = async(
  roster: RosterRequest,
): Promise<RosterResponse> => {
  const response = await axios.post<RosterResponse>('api/roster/delete', roster)
    .then(res => ({...res.data, __typename: ROSTER_RESPONSE}))
    .catch((err: string): RosterResponse => ({
      __typename: ROSTER_RESPONSE,
      success: false,
      rosterID: -1,
      errMsg: err
    }));
  return response;
};

export const fetchRosterStudentsAsync = async(payload: RosterRequest): Promise<RosterStudentResponse> => {
  const response = await axios.post<RosterStudentResponse>('api/roster/students', payload)
    .then(res => ({...res.data, __typename: ROSTER_STUDENT_RESPONSE}))
    .catch((err): RosterStudentResponse => ({
      __typename: ROSTER_STUDENT_RESPONSE,
      success: false,
      errMsg: err,
      studentInfoList: []
    }));

  return response;
};

export const deleteRosterStudentAsync = async(studentInfo: StudentInfo): Promise<RosterResponse> => {
  const response = await axios.post<RosterResponse>(
    'api/roster/deleteStudent',
    studentInfo.studentID,
    {
      headers: {
        'content-type': 'application/json'
      }
    }
  )
    .then(res => ({...res.data, __typename: ROSTER_RESPONSE}))
    .catch((err): RosterResponse => ({
      __typename: ROSTER_RESPONSE,
      success: false,
      errMsg: err,
      rosterID: studentInfo.rosterId
    }));
  return response;
};